import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchSingleCatagory } from "../../redux/actions";
import _ from "lodash";

import Header from "../decoration/header";
import ProductPanel from "./productPanel";
import RelatedProductsPanel from "./relatedProductsPanel";
import Footer from "../footer/footer";

import "./singleItem.css";

class SingleItem extends Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    this.state = {
      loading: true,
      hasError: false
    };
  }
  goBack(){
      this.props.history.goBack();
  }
  componentDidMount() {

    if (_.isEmpty(this.props.currentCategory)) {
      const { catename } = this.props.match.params;
      this.props.fetchSingleCatagory(catename);
    }

    if (this.state.loading) {
      this.setState({
        loading: false
      });
    }
  }

  componentDidCatch() {
    this.setState({
      hasError: true
    });
  }

  render() {
    if (this.state.loading) {
      return <div>Loading...</div>;
    }

    const singleItem = this.props.singleItem;
    let customDiv = null;
    if (singleItem !== undefined) {
      let desc = singleItem;
      customDiv = (
        <div>
          <Header />
          <div id='catagoryPanelCaption'><h1>OUR SHOP</h1></div>
          <button className="btn btn-back" onClick={this.goBack}><i className="fas fa-angle-left"></i>Go Back</button>
          <ProductPanel imgURL={singleItem.imageURL} desc={desc} />
          {/* <ProductPanel imgURL={"http://www.independentmediators.co.uk/wp-content/uploads/2016/02/placeholder-image.jpg"} desc={desc} /> */}
         
          <RelatedProductsPanel
            catename={this.props.match.params.catename}
            relatedList={this.props.currentCategory}
          />
          <Footer />
        </div>
      );
    } else {
      customDiv = <div>Loading...</div>;
    }

    return <div className="SingleItem">{customDiv}</div>;
  }
}

function mapStateToProps(state, ownProps) {
  return {
    currentCategory: state.singleCategory,
    singleItem: state.singleCategory[ownProps.match.params.id]
  };
}

export default connect(mapStateToProps,{ fetchSingleCatagory })(SingleItem);



// WEBPACK FOOTER //
// ./src/components/singleItem/singleItem.js